import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import { Redirect } from 'react-router-dom';

function LoginPage({login, loginError, user}) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const loginSubmit = (event) => {
        event.preventDefault();
        login(email, password);
    }
    return (
        user ?
        <Redirect to='/' />
        :
        <Container className="col-8 offset-2" style={{textAlign: 'left'}}>
            <br />
            <Form onSubmit={loginSubmit}>
                <Form.Group controlId="formEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" value={email} onChange={(event) => setEmail(event.target.value)} />
                </Form.Group>
                <Form.Group controlId="formPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" value={password} onChange={(event) => setPassword(event.target.value)} />
                </Form.Group>
                <Button variant="primary" type="submit">
                    Submit
                </Button>
                {
                    loginError ?
                        <Alert variant="danger" className="mt-4">{loginError}</Alert>
                        : null
                }
            </Form>
        </Container>
    );
}

export default LoginPage;
